<template>
  <div class="announcementDetails">
    <!--    <van-nav-bar left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="18" color="black"/>
      </template>
    </van-nav-bar>-->

    <article class="details">
      <div class="details-title">
        {{ detailsInfo.BT ? detailsInfo.BT : '标题' }}
      </div>
      <div class="details-date">
        {{ detailsInfo.FBSJ ? detailsInfo.FBSJ : '时间' }}
      </div>
      <div
        class="details-content"
        v-html="detailsInfo.TZNR ? detailsInfo.TZNR : '<p>暂无内容</p>'"
      ></div>
    </article>
    <footer
      class="footer"
      v-show="detailsInfo.FJ != undefined && detailsInfo.FJ.length > 0"
    >
      <div class="pdf-file" @click="clickTips">
        <img
          class="pdf-icon"
          :src="require('@/assets/img/projectAppoint/pdf.png')"
          alt=""
        />
        <ul>
          <li
            v-for="(item, index) in detailsInfo.FJ ? detailsInfo.FJ : []"
            :key="index"
          >
            <div class="pdf-name text-flow-ellipsis-multiple" target="_self">
              {{ item.name }}
            </div>
          </li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>
import api from '@/utils/api/announce'

export default {
  name: 'announcementDetails',
  data() {
    return {
      pdfUrl: [],
      rid: '',
      detailsInfo: {}
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    getDetails() {
      api
        .getAnnouncementDetails({
          id: this.rid
        })
        .then(res => {
          // console.log(res)
          setTimeout(() => {
            this.detailsInfo = res
          })
        })
    },
    clickTips() {
      // this.$notify({
      //   type: 'primary',
      //   message: '请到政务网查看'
      // })
      this.$toast.fail('请到政务网查看')
    }
  },
  created() {
    this.rid = this.$route.query.rid
  },
  mounted() {
    this.getDetails()
  }
}
</script>

<style lang="scss" scoped>
.announcementDetails {
  background: white;
  /* height: 100vh; */
  ::v-deep img {
    width: 100%;
  }
  .details {
    padding: 20px 20px 60px 20px;
    background: white;
    min-height: calc(100vh - 100px);
  }

  .details-title {
    font-size: 17px;
    font-weight: bold;
    color: #333333;
    line-height: 1.5;
  }

  .details-date {
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    padding-top: 15px;
    padding-bottom: 25px;
  }

  .details-content {
    max-width: calc(100vh);
    overflow: scroll;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    line-height: 1.5;
  }

  .footer {
    background-color: white;
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 15px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);

    .pdf-file {
      display: flex;
      align-items: center;

      .pdf-icon {
        width: 30px;
        height: 30px;
      }

      .pdf-name {
        font-size: 12px;
        font-weight: 500;
        text-decoration: underline;
        color: #1d84ff;
        line-height: 1.5;
        padding-left: 10px;
        padding-right: 30px;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .text-flow-ellipsis-multiple {
        /* 多余内容省略号处理-多行 */
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
  }
}
</style>
